var d = class {
  known;
  target;
};
var g = (s => (s.KnowIt = "KNOW_IT", s.OwnIt = "OWN_IT", s))(g || {}),
  l = class {
    KNOW_IT;
    OWN_IT;
  };
var c;
(r => {
  let o;
  (n => (n.Course = "COURSE", n.Unit = "UNIT", n.Category = "CATEGORY", n.Class = "CLASS", n.Root = "ROOT"))(o = r.ContainerType ||= {});
  let m;
  (e => (e.List = "LIST", e.Course = "COURSE", e.Unit = "UNIT", e.UnitLesson = "UNITLESSON", e.Document = "DOCUMENT", e.PdfDocument = "PDF_DOCUMENT", e.Reference = "REFERENCE", e.ExternalDocument = "EXTERNAL_DOCUMENT", e.DownloadLink = "DOWNLOAD_LINK"))(m = r.LessonType ||= {});
  let s;
  (a => (a.Available = "AVAILABLE", a.Missing = "MISSING"))(s = r.SuggestionStatus ||= {});
})(c ||= {});
var I = (r => (r.PASSED = "PASSED", r.FAILED = "FAILED", r.NOT_STARTED = "NOT_STARTED", r))(I || {}),
  f = (r => (r.INCOMPLETE = "INCOMPLETE", r.COMPLETED = "COMPLETED", r.NOT_STARTED = "NOT_STARTED", r))(f || {});
var L;
(a => {
  class o {
    id;
    aaid;
    uuid;
    version;
    creator;
    creator_url;
    creator_application;
    is_ordered;
    is_transliteration_shown;
    LearningFeatures;
    side1_language_key;
    side2_language_key;
    side1_title;
    side2_title;
    name;
    description;
  }
  a.Head = o;
  class m {
    is_PreviewIt;
    is_SR_RecognizeIt;
    is_Written_RecognizeIt;
    is_SR_ProduceIt;
    is_Written_ProduceIt;
  }
  a.LearningFeatures = m;
  class s {
    head;
    cards;
  }
  a.List = s;
  class r {
    description;
    lessons;
    name;
  }
  a.ActivityTemplate = r;
  class p {
    dataUrl;
    isB4u;
    isSpeech;
    moduleUrl;
    name;
    numItems;
    showSkill;
  }
  a.Activity = p;
  class u {
    activities;
    isAssessment;
    name;
    number;
  }
  a.Lesson = u;
})(L ||= {});
var x;
(t => {
  let o;
  (e => (e.U = "U", e.L = "L", e.A = "A", e.H = "H", e.D = "D"))(o = t.Bucket ||= {});
  class m {
    target;
    cards;
  }
  t.MoveRequest = m;
  class s {
    total;
    stale;
    fresh;
    archive;
  }
  t.Statistics = s;
  class r {
    filter;
    hids;
    limit;
  }
  t.RefreshQuery = r;
  class p {
    comment;
    hid;
    hideExportPdf;
    picture;
    pictureAttribution;
    position;
    sideOnePhrase;
    sideTwoPhrase;
    sideOneSound;
    sideTwoSound;
    sideTwoWordsCount;
  }
  t.ExtendedCardSummary = p;
  class u {
    card;
    mli;
    expires;
  }
  t.RefreshCard = u;
  class a {
    lastSynchronized;
    items;
  }
  t.SyncRequest = a;
})(x ||= {});
export { g as AltAnswerMode, l as AltAnswerResponse, I as AssessmentStatus, f as CompletionStatus, c as ContentBrowse, d as LanguageSelector, L as ListRepository, x as MLI };
